"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

export type SimpleKeyValueRow = {
  label: React.ReactNode;
  value: React.ReactNode;
};

export type SimpleKeyValueTableProps = {
  rows: SimpleKeyValueRow[];
  footer?: React.ReactNode;
  className?: string;
};

export function SimpleKeyValueTable({
  rows,
  footer,
  className,
}: SimpleKeyValueTableProps) {
  return (
    <div className={cn("divide-y divide-border/60", className)}>
      {rows.map((row, idx) => (
        <div key={idx} className="flex items-center justify-between bg-white px-3 py-1">
          <span className="text-[11px] leading-4 text-muted-foreground">{row.label}</span>
          <span className="text-[11px] leading-4 tabular-nums text-foreground">{row.value}</span>
        </div>
      ))}
      {footer ? (
        <div className="bg-white px-3 py-1">
          <p className="text-[11px] leading-4 text-muted-foreground">{footer}</p>
        </div>
      ) : null}
    </div>
  );
}
